import Configuration from './configuration';

export function buildPortalBaseUrl() {
  const SITE_ENV = Configuration.value('VUE_APP_SITE_ENV');
  const qaSite = 'https://stg.e6golf.com';
  // const qaSite = 'http://localhost:3000';
  const prodSite = 'https://e6golf.com';

  return SITE_ENV === 'staging' ? qaSite : SITE_ENV === 'production' ? prodSite : qaSite;
}

export function buildPortalAuthQuery() {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('e6User') || '{}');

  if (!token || !user?.me?.id || !user?.me?.email) {
    return null;
  }

  const query = new URLSearchParams({
    token,
    id: user.me.id,
    email: user.me.email,
    permissions: JSON.stringify(user.me.permissions || []),
  });

  return query;
}

export function buildPortalUrl(pathname) {
  const baseUrl = buildPortalBaseUrl();
  const query = buildPortalAuthQuery();
  if (!query) {
    return null;
  }

  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${baseUrl}${normalizedPath}?${query.toString()}`;
}
